import { createElement } from 'react';
import cx from 'classnames';
import { Tab } from '@alifd/next';
export const TabContainerItem = (props) => {
    const { className, tab, key, ...restProps } = props;
    return createElement(Tab.Item, { className: cx(className, 'fusion-ui-tab'), ...restProps, title: tab, primaryKey: key });
};
TabContainerItem.displayName = 'TabContainerItem';
